// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_zbyfM { 
  border-bottom:1px solid var( --light-grey );
}
.header_zbyfM > * {
  margin : 8px 0;
}

.summary_HZBWS {
  color : var( --light-grey );
  margin-left : 10px;
}

.warn_nWm0q {
  margin-left:10px;
  color : var( --pink );
}

.hint_YJYzP {
  color : var( --light-grey );
  font-size : var( --font-size-large );
  background:white; 
  overflow:auto;
  height:100%; 
  width:100%;
  margin:0;
  text-align:center;
  padding-top:40px;
}

.json_I5dBh {
  background:white; 
  overflow:auto;
  height:100%; 
  width:100%;
  margin:0;
}

.uploading_AhA2X {
  color : var( --pink );
  font-size : var( --font-size-large );
  position:absolute;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  width : 100%;
  height: 100%;
  background : rgba( 255, 255, 255, 0.6 );
}
.uploading_AhA2X div { 
  margin : 10px
}
`, "",{"version":3,"sources":["webpack://./src/screens/blueprint/importRawBlueprintsScreen.css"],"names":[],"mappings":"AAGA;EACE,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE;AACF","sourcesContent":["@import \"../../style/theme.css\";\n\n\n.header { \n  border-bottom:1px solid var( --light-grey );\n}\n.header > * {\n  margin : 8px 0;\n}\n\n.summary {\n  color : var( --light-grey );\n  margin-left : 10px;\n}\n\n.warn {\n  margin-left:10px;\n  color : var( --pink );\n}\n\n.hint {\n  color : var( --light-grey );\n  font-size : var( --font-size-large );\n  background:white; \n  overflow:auto;\n  height:100%; \n  width:100%;\n  margin:0;\n  text-align:center;\n  padding-top:40px;\n}\n\n.json {\n  background:white; \n  overflow:auto;\n  height:100%; \n  width:100%;\n  margin:0;\n}\n\n.uploading {\n  color : var( --pink );\n  font-size : var( --font-size-large );\n  position:absolute;\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  width : 100%;\n  height: 100%;\n  background : rgba( 255, 255, 255, 0.6 );\n}\n.uploading div { \n  margin : 10px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_zbyfM`,
	"summary": `summary_HZBWS`,
	"warn": `warn_nWm0q`,
	"hint": `hint_YJYzP`,
	"json": `json_I5dBh`,
	"uploading": `uploading_AhA2X`
};
export default ___CSS_LOADER_EXPORT___;
